import { render, staticRenderFns } from "./smallNav.vue?vue&type=template&id=dab1a524&scoped=true"
import script from "./smallNav.vue?vue&type=script&lang=js"
export * from "./smallNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab1a524",
  null
  
)

export default component.exports